export const intervalCountFromDarkStore = [[1, 2999], [3000, 3999], [4000, 4999], [5000, 5999], [6000, 9999]]
export const citiesDS = [
    "Москва",
    "МО",
    "Санкт-Петербург",
    "Новосибирск",
    "Казань",
    "Ростов-на-Дону",
    "Екатеринбург",
    "Краснодар",
    "Нижний Новгород",
    "Иркутск",
    "Тула",
    "Тюмень",
    "Челябинск"
]

export type TitleKeys = 0 | 3000 | 4000 | 5000 | 6000;

export const titleDSChart: Record<TitleKeys, string> = {
    0: 'до 3000',
    3000: '3000-4000',
    4000: '4000-5000',
    5000: '5000-6000',
    6000: 'свыше 6000'
};